import { graphql } from 'relay-runtime';

export const STATS_SNAPSHOT_QUERY = graphql`
  query StatsSnapshotQuery($username: String, $internalId: String) {
    unified {
      unifiedProfile(
        unifiedProfileUsername: $username
        internalId: $internalId
      ) {
        ... on UnifiedProfile {
          forums {
            ... on UnifiedForums {
              id
              snapshot {
                ... on UnifiedForumsSnapshot {
                  id
                  rank
                  acceptedAnswersCreated
                  answersCreated
                  articlesCreated
                  likesReceived
                  totalPosts
                }
                ... on UnifiedQueryError {
                  identifier
                  message
                  extensions {
                    errorType
                    statusCode
                  }
                }
              }
            }
          }
        }
        ... on UnifiedQueryError {
          identifier
          message
          extensions {
            errorType
            statusCode
          }
        }
      }
    }
  }
`;
